import React from 'react';
import Layout from '../components/Layout';
import { Music, ExternalLink } from 'lucide-react';
import { useTranslation } from '../context/TranslationContext';
import SEO from '../components/SEO';
import { PAGE_SEO } from '../data/seoMeta';

function MusicPage() {
  var { t } = useTranslation();
  var albumImage = 'https://static.wixstatic.com/media/4a2ebb_808ea6fb5829472cbeae22e972656b8c~mv2.jpg';

  return (
    <Layout>
      <SEO title={PAGE_SEO['music'].title} description={PAGE_SEO['music'].description} url="/music" />
      <div className="pt-32 pb-20 bg-black min-h-screen">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <p className="text-[#d4af37] text-sm tracking-widest uppercase mb-4">{t('musicRecordings')}</p>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-8">{t('musicTitle')}</h1>
          <p className="text-xl text-neutral-400 mb-16">
            {t('musicInvite')}
          </p>

          <div className="relative max-w-md mx-auto mb-12">
            <img
              src={albumImage}
              alt="Art in Trumpet Album"
              className="w-full aspect-square object-cover rounded-2xl shadow-2xl shadow-[#d4af37]/20"
              referrerPolicy="no-referrer"
            />
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/60 to-transparent" />
          </div>

          <h2 className="text-3xl font-bold text-white mb-4">{t('musicAlbumTitle')}</h2>
          <p className="text-neutral-400 mb-8">{t('musicAlbumArtist')}</p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://geo.itunes.apple.com/us/album/art-in-trumpet/1368677032?itsct=music_box_link&itscg=30200&ct=albums_art_in_trumpet&ls=1&app=music"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-white text-black px-8 py-4 rounded-full font-semibold hover:bg-[#d4af37] transition-all duration-300"
            >
              <Music className="w-5 h-5" />
              {t('listenAppleMusic')}
              <ExternalLink className="w-4 h-4" />
            </a>
            <a
              href="https://open.spotify.com/search/isaias%20jimenez%20art%20in%20trumpet"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#1DB954] text-white px-8 py-4 rounded-full font-semibold hover:brightness-110 transition-all duration-300"
            >
              {t('listenSpotify')}
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default MusicPage;
